export default {
  // 基础菜单
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.account.logout': '退出登录',
  
  // 用户端菜单
  'menu.dashboard': '工作台',
  'menu.config': '基础配置',
  'menu.asset-library': '资产库',
  'menu.asset-library.basic': '基础资产库',
  'menu.asset-library.product': '产品资产库',
  'menu.asset-library.keyword': '关键词',
  'menu.material': '素材管理',
  'menu.material.image': '图片素材',
  'menu.material.video': '视频素材',
  'menu.material.article': '文章素材',
  'menu.material.article-command': '文章AI指令',
  'menu.material.article-command-v2': '文章AI指令(新)',
  'menu.media-release': '媒体发稿',
  'menu.media-release.self-media': '自媒体',
  'menu.media-release.media-platform': '媒体平台',
  'menu.media-release.overseas': '海外媒体',
  'menu.media-release.order-list': '发稿订单',
  'menu.publish': '发布管理',
  'menu.finance': '财务管理',
  'menu.report': '数据报表',
  'menu.case': '案例介绍',
  
  // 代理端菜单
  'menu.agent': '用户管理',
  'menu.agent.cases': '案例库',
  'menu.agent.price': '价格设置',
  'menu.agent-setting': '用户设置',
  'menu.agent-setting.keyword': '关键词管理',
  'menu.agent-setting.image': '图片管理',
  'menu.agent-setting.article': '文章管理',
  'menu.agent-setting.video': '视频管理',
  'menu.agent-setting.publish-detail': '发布明细',
  'menu.agent-setting.auth': '授权管理',
  
  // OEM端菜单
  'menu.oem': 'OEM管理',
  'menu.oem.setting': '系统设置',
  'menu.oem.domain': '域名管理',
  
  // 超管端菜单
  'menu.admin': '系统管理',
  'menu.admin.users': '用户管理',
  'menu.admin.price': '价格设置',
  'menu.admin.material': '素材管理',
  'menu.admin.publish': '发布管理',
  'menu.admin.finance': '账单管理',
  'menu.admin.oem-domain': 'OEM域名管理',
  'menu.admin.oem-site': 'OEM网站设置',
  'menu.admin.site-setting': '网站设置',
  'menu.admin.ai-command': '文章AI指令',
  'menu.admin.platform': '平台管理',
  'menu.admin.media-platform-setting': '媒体平台设置',
  
  // 异常页
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
};
